export const getOrganizationsList = (store) => store.organizations.data;
export const getIsLoading = (store) => store.organizations.isLoading;
